import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import { Modal, TextInput, Label } from "flowbite-react";
import Head_data from "../components/Head_data";
import GlobalContext from "../connections/GlobalContext";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEye, FaTrash, FaPrint } from "react-icons/fa";
import EstimateDetailsTable from "./EstimateDetailsTable";
import { FaExchangeAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import image from "./logo.png";
import { Tooltip } from "react-tooltip";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Calendar as CalendarIcon } from "lucide-react";
import engineGif from "../image/engine.gif";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { FaStickyNote } from "react-icons/fa";
import {
  ShieldCheckIcon,
  ShieldExclamationIcon,
} from "@heroicons/react/24/solid";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Logo from "../image/logo.jpg";
import html2pdf from "html2pdf.js";

const Estimate_data = () => {
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [additionalEstimate, setAdditionalEstimate] = useState(false);
  const [add_show, setAdd_show] = useState(false);
  const [flag_branch, setFlag_branch] = useState(
    sessionStorage.getItem("branch")
  );
  const [flag_berror, setFlag_berror] = useState("");
  const [img_data, setImg_data] = useState([]);
  const { globalValue } = useContext(GlobalContext);
  const [brand, setBrand] = useState();
  const [model1, setModel1] = useState();
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState("normal");

  const [surviour_name, setSurviour_name] = useState("");
  const [mobile_no, setMobile_no] = useState("");
  const [email_id, setEmail_id] = useState("");
  const [surviour_model, setSurviour_model] = useState(false);

  const [photos, setPhotos] = useState([]);
  const [openCard, setOpenCard] = useState(false);

  const [company_name, setCompany_name] = useState("");
  const [insurance_no, setInsurance_no] = useState("");
  const [company_error, setCompany_error] = useState("");
  const [insurance_error, setInsurance_error] = useState("");
  const [temp_brand_modal, setTemp_brand_modal] = useState("");

  const [s_date, setS_date] = useState("");
  const [s_date_error, setS_date_error] = useState("");
  const [e_date, setE_date] = useState("");
  const [e_date_error, setE_date_error] = useState("");
  const [rcbook, setRcbook] = useState("");

  const [rc_start, setRc_start] = useState("");
  const [rc_start_error, setRc_start_error] = useState("");
  const [rc_end, setRc_end] = useState("");
  const [rc_end_error, setRc_end_error] = useState("");

  const [license, setLicense] = useState("");
  const [license_start, setLicense_start] = useState("");
  const [license_start_error, setLicense_start_error] = useState("");
  const [license_end, setLicense_end] = useState("");
  const [license_end_error, setLicense_end_error] = useState("");

  const [rcbookError, setRcbookError] = useState("");
  const [licenseError, setLicenseError] = useState("");
  const [isinsurance, setIsInsurance] = useState(false);
  const [customer_id, setCustomer_id] = useState("");

  const [value, setValue] = useState("");
  const [insurance_branch, setInsurance_branch] = useState();
  const [b_mobile_no, setB_mobile_no] = useState("");
  const [b_address_no, setB_address_no] = useState("");

  const [insurance_type, setInsurance_type] = useState("");
  const [insurance_type_error, setInsurance_type_error] = useState("");
  const [branch_list, setBranche_list] = useState([]);

  const [branch_code, setBranch_code] = useState("");
  const [branch_code_error, setBranch_code_error] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [showInsuranceModal, setShowInsuranceModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState(data);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [driven_km, setDriven_km] = useState(0);

  const [isDisabled, setIsDisabled] = useState(false);

  // ─── Remark Modal State ───────────────────────────────────────────────────
  const [remarkModalOpen, setRemarkModalOpen] = useState(false);
  const [remarkRowId, setRemarkRowId] = useState(null);
  const [remark, setRemark] = useState("");
  const [debouncedRemark, setDebouncedRemark] = useState("");
  const [remarkSaving, setRemarkSaving] = useState(false);
  const [remarkSaved, setRemarkSaved] = useState(false);
  // ─────────────────────────────────────────────────────────────────────────

  // ─── PDF Remark State ─────────────────────────────────────────────────────
  const [pdfRemark, setPdfRemark] = useState("");
  // ─────────────────────────────────────────────────────────────────────────

  useEffect(() => {
    const position = sessionStorage.getItem("position");
    if (position === "superadmin") {
      setIsDisabled(true);
    }
  }, []);

  useEffect(() => {
    const filteredData = data.filter(
      (branch) => {
        // Search term filter
        const matchesSearch =
          branch["customer_name"]
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          branch["vehicle_no"]
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          branch["brand"]?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          branch["model"]?.toLowerCase().includes(searchTerm.toLowerCase());

        // Date range filter based on date field used in card
        let matchesDate = true;
        if (startDate || endDate) {
          const itemDate = new Date(branch.date);
          const itemDateOnly = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate());
          
          if (startDate) {
            const start = new Date(startDate);
            const startDateOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            if (itemDateOnly < startDateOnly) matchesDate = false;
          }
          
          if (endDate && matchesDate) {
            const end = new Date(endDate);
            const endDateOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
            if (itemDateOnly > endDateOnly) matchesDate = false;
          }
        }

        return matchesSearch && matchesDate;
      }
    );
    setFiltered(filteredData);
  }, [searchTerm, data, startDate, endDate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "branch_code") setBranch_code(value);
    if (name === "company") {
      setCompany_name(value);
      setFilteredOptions([]);
      setB_mobile_no("");
      setInsurance_branch("");
      setB_address_no("");
      setBranche_list([]);
      for (let i = 0; i < insurance.length; i++) {
        console.log(insurance[i]);
        if (insurance[i][1] === value) {
          if (Array.isArray(insurance[i][3])) {
            setBranche_list((prevList) => [...insurance[i][3]]);
          }
          break;
        }
      }
    }

    if (name === "insurance") {
      setInsurance_no(value);
    }
    if (name === "s_date") setS_date(value);
    if (name === "e_date") setE_date(value);
    if (name === "rc_start") setRc_start(value);
    if (name === "rc_end") setRc_end(value);
    if (name === "license_start") setLicense_start(value);
    if (name === "license_end") setLicense_end(value);
    if (name === "insurance_type") setInsurance_type(value);

    validate(name, value);
  };

  const validate = (fieldName, value) => {
    switch (fieldName) {
      case "company":
        if (!value) setCompany_error("Insurance company name  is required.");
        else setCompany_error("");
        break;
      case "insurance":
        if (!value) setInsurance_error("Insurance number  is required.");
        else setInsurance_error("");
        break;
      case "insurance_type":
        if (!value) setInsurance_type_error("Insurance type  is required.");
        else setInsurance_type_error("");
        break;
      case "s_date":
        if (!value) setS_date_error("date  is required.");
        else setS_date_error("");
        break;

      case "e_date":
        if (!value) setE_date_error("date  is required.");
        else setE_date_error("");
        break;

      case "branch_code":
        if (!value) setBranch_code_error("date  is required.");
        else setBranch_code_error("");
        break;
      case "rc_start":
        if (!value) setRc_start_error("date  is required.");
        else setRc_start_error("");
        break;
      case "rc_end":
        if (!value) setRc_end_error("date  is required.");
        else setRc_end_error("");
        break;
      case "license_start":
        if (!value) setLicense_start_error("date  is required.");
        else setLicense_start_error("");
        break;
      case "license_end":
        if (!value) setLicense_end_error("date  is required.");
        else setLicense_end_error("");
        break;

      default:
        break;
    }
  };
  const [types, setTypes] = useState([]);
  const insurance_type_list = async () => {
    const response = await axios.get(`${globalValue}/insurance_type`, {});
    setTypes(response.data);
  };

  useEffect(() => {
    fetchData();

    fetchData1();
    fetchData2();
    insurance_type_list();
  }, []);

  const handleRcbookChange = (e) => {
    let value = e.target.value;

    if (value.length > 12) return;

    let formattedValue = value.replace(
      /^([A-Z]{2})(\d{0,2})([A-Z]{0,2})(\d{0,4})$/,
      (_, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-")
    );

    setRcbook(value);

    const rcbookPattern = /^[A-Z]{2}-\d{2}-[A-Z]{1,2}-\d{4}$/;
  };

  const handleLicenseChange = (e) => {
    let value = e.target.value;

    if (value.length > 14) return;

    let formattedValue = value.replace(/^([A-Z]{2})(\d{0,12})$/, (_, p1, p2) =>
      [p1, p2].filter(Boolean).join("-")
    );

    setLicense(value);

    const licensePattern = /^[A-Z]{2}-\d{6,12}$/;
  };

  const [dis, setDis] = useState(true);
  const handlePrint = () => {
    const element = document.getElementById("pdf-content");

    const options = {
      margin: [5, 5, 5, 5],
      filename: "quotation.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4", orientation: "p" },
      pagebreak: { mode: ["css", "legacy"] },
    };

    html2pdf()
      .from(element)
      .set(options)
      .save();
  };

  const [insurance, setInsurance] = useState([]);
  const fetchDataInsurance = async () => {
    setLoading(true);
    try {
      const response = await fetch(globalValue + "/insurance", {
        method: "GET",
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setInsurance(data);
    } catch (error) {
      console.error("Error fetching insurance data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/customers`, {
        params: {
          data: flag_branch,
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      let data = response.data;
      const formattedData = data.map((item) => ({
        value: item[1],
        label: item[2],
        v_no: item[4],
      }));
      setCustomers(formattedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/estimate_display`, {
        params: {
          data: flag_branch,
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [spares, setSpares] = useState([]);
  const fetchData2 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/spares`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });

      setSpares(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [first, setFirst] = useState(false);
  const navigate = useNavigate();

  const [branches, setBranches] = useState([]);
  const fetchData1 = () => {
    fetch(globalValue + "/branches", {
      method: "GET",
      headers: {
        "x-access-token": sessionStorage.getItem("token"),
      },
    })
      .then((res) => res.json())
      .then((dat) => {
        setBranches(dat);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    fetchData();
    fetchData2();

    fetchData1();
    fetchDetails();
    fetchDataInsurance();
  }, []);

  const handleSubmitInsurance = async () => {
    setLoading(true);
    try {
      if (
        !company_name ||
        !insurance_no ||
        !s_date ||
        !e_date ||
        !branch_code ||
        !rcbook ||
        !license
      ) {
        Swal.fire({
          icon: "warning",
          title: "Please fill all the fields",
        });
        return;
      }
      if (
        company_error ||
        insurance_error ||
        s_date_error ||
        e_date_error ||
        branch_code_error
      ) {
        Swal.fire({
          icon: "warning",
          title: "Please correct the errors in the form",
        });
        return;
      }
      const response = await axios.post(
        `${globalValue}/insurance_estimate_update`,
        {
          company: company_name,
          insurance: insurance_no,
          s_date: s_date,
          e_date: e_date,
          branch_code: branch_code,
          rcbook: rcbook,
          license: license,
          rc_start: rc_start,
          rc_end: rc_end,
          license_start: license_start,
          license_end: license_end,
          insurance_type: insurance_type,
          insurance_branch: insurance_branch,
          b_mobile_no: b_mobile_no,
          email_id: b_address_no,
          job_card_id: job_card_id,
          customer_id: customer_id,
        }
      );
      if (response.data === "success") {
        Swal.fire({
          icon: "success",
          title: "Insurance details added successfully",
        });
        setShowInsuranceModal(false);
        setCompany_name("");
        fetchDetails();
      } else {
        Swal.fire({
          icon: "warning",
          title: "Insurance details already exists",
        });
      }
    } catch (error) {
      console.error("Error submitting insurance details:", error);
      Swal.fire({
        icon: "error",
        title: "Error submitting insurance details",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (selectedCustomer && date) {
      setLoading(true);
      try {
        const formData = new FormData();

        formData.append("customer", selectedCustomer.value);
        formData.append("date", date);
        formData.append("additionalEstimate", additionalEstimate);
        formData.append("flag_branch", flag_branch);
        formData.append("insurance_valid", insurance_valid);
        formData.append("driven_km", driven_km);

        for (const [index, photo] of photos.entries()) {
          const blob = await fetch(photo).then((res) => res.blob());
          formData.append(`photos_${index}`, blob, `photo_${index}.png`);
        }

        const response = await axios.post(
          `${globalValue}/estimate_cust`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "x-access-token": sessionStorage.getItem("token"),
            },
          }
        );

        if (response.data === "success") {
          setModalOpen(false);
          fetchData();
          fetchDetails();
          Swal.fire({
            icon: "success",
            title: "Job Card Created Successfully",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "You have already Pending Estimate Entry",
          });
        }
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "warning",
          title: "You doesn't have main estimate entry to add additional entry",
        });
      } finally {
        setLoading(false);
      }
    } else {
      alert("Please select a customer and enter a date.");
    }
  };

  const handleSave1 = async (
    customer,
    link,
    date,
    additionalEstimate,
    flag_branch,
    estimate_id
  ) => {
    setLoading(true);
    try {
      const formData = new FormData();
      console.log(customer, link, date, additionalEstimate, flag_branch);

      formData.append("customer", customer);
      formData.append("date", date);
      formData.append("additionalEstimate", additionalEstimate);
      formData.append("flag_branch", flag_branch);
      formData.append("link", link);
      formData.append("estimate_id", estimate_id);

      const response = await axios.post(
        `${globalValue}/estimate_cust`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      if (response.data === "success") {
        setModalOpen(false);
        fetchData();
        fetchDetails();
        Swal.fire({
          icon: "success",
          title: "Estimate Added Successfully",
        });
      } else if (response.data === "completed") {
        Swal.fire({
          icon: "warning",
          title: "This estimate is completed",
        });
      } else {
        Swal.fire({
          icon: "warning",
          title: "You have already Pending Estimate Entry",
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "warning",
        title: "You doesn't have main estimate entry to add additional entry",
      });
    } finally {
      setLoading(false);
    }
  };
  const [show, setShow] = useState(false);
  const [est_is, setEst_id] = useState("");
  const [view_data, setView_data] = useState([]);

  const view_details = async (est_is) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/view_details`,
        { est_is },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setView_data(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const transfer_details = async (est_is, staffs) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/transfer_details`,
        { est_is, staffs, branch: sessionStorage.getItem("branch") },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      if (response.data === "success") {
        console.log("success");
        fetchData();
        fetchDetails();
        setAdd_show(false);
        Swal.fire({
          icon: "success",
          title: "Estimate added to service log",
        });
        setShow1(false);
      } else {
        console.log(response);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const [add_data, setAdd_data] = useState([]);
  const add_details = async (link) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/add_details`,
        { link },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setAdd_data(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const spare_name = (id) => {
    let name = "";
    for (let i = 0; i < spares.length; i++) {
      if (spares[i][1] === id) {
        name = spares[i][2];
      }
    }
    return name;
  };
  const [pdfpopup, setPdfpopup] = useState(false);
  const [pdf_data, setPdf_data] = useState([]);
  const makePdf = async (data) => {
    console.log(data["estimate_id"]);
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/pdf_insurance`,
        {
          id: data["estimate_id"],
          branch: sessionStorage.getItem("branch"),
          mode: data["mode"],
          link: data["link"],
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setPdf_data(response.data);
      console.log(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
    setPdfpopup(true);
  };

  const [pdf_insurance_data, setPdf_insurance_data] = useState([]);
  const [temp_job_card_no, setTemp_job_card_no] = useState("");

  const [pdfpopup1, setPdfpopup1] = useState(false);

  // ─── makePdf1: fetch PDF data + remark together ───────────────────────────
  const makePdf1 = async (data) => {
    setLoading(true);
    try {
      const { data: pdfData } = await axios.post(
        `${globalValue}/pdf_insurance`,
        {
          id: data["estimate_id"],
          branch: sessionStorage.getItem("branch"),
          mode: data["mode"],
          link: data["link"],
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setPdf_insurance_data(pdfData);

      // ─── Fetch remark for this estimate ───────────────────────────────
      try {
        const remarkRes = await axios.get(`${globalValue}/get_remark`, {
          params: { table: "estimate_data", id: data["estimate_id"] },
          headers: { "x-access-token": sessionStorage.getItem("token") },
        });
        setPdfRemark(
          remarkRes.data.success === 1 ? remarkRes.data.remark || "" : ""
        );
      } catch {
        setPdfRemark("");
      }
      // ──────────────────────────────────────────────────────────────────

      setPdfpopup1(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────

  const delete_estimate = async (id, link, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.post(
            `${globalValue}/delete_estimate`,
            { id, link, status },
            {
              headers: {
                "x-access-token": sessionStorage.getItem("token"),
              },
            }
          );

          console.log(response.data);
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Estimate deleted successfully",
            });
          } else {
            Swal.fire({
              icon: "warning",
              title: "Estimate not deleted successfully",
            });
          }
          fetchData();
          fetchData2();
          fetchData1();
          fetchDetails();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error deleting estimate",
          });
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const [showCamera, setShowCamera] = useState(false);
  const [videoDevices, setVideoDevices] = useState([]);
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const videoRef = React.useRef(null);
  const streamRef = React.useRef(null);

  const handleOpenCamera = async () => {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
      document.getElementById('mobile-camera-input').click();
      return;
    }

    setShowCamera(true);
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoInputs = devices.filter((device) => device.kind === "videoinput");
      setVideoDevices(videoInputs);

      if (videoInputs.length > 0) {
        setSelectedDeviceId(videoInputs[0].deviceId);
        startCameraStream(videoInputs[0].deviceId);
      } else {
        Swal.fire("Error", "No camera found on this device.", "error");
        setShowCamera(false);
      }
    } catch (error) {
      console.error("Error enumerating devices:", error);
      Swal.fire("Error", "Unable to access camera devices.", "error");
      setShowCamera(false);
    }
  };

  const startCameraStream = async (deviceId) => {
    stopCameraStream();
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { deviceId: { exact: deviceId } },
      });
      streamRef.current = stream;
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        videoRef.current.play();
      }
    } catch (error) {
      console.error("Error starting stream:", error);
      Swal.fire("Error", "Unable to start camera stream.", "error");
    }
  };

  const stopCameraStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }
  };

  const handleCloseCamera = () => {
    stopCameraStream();
    setShowCamera(false);
  };

  const handleCapturePhoto = () => {
    if (videoRef.current) {
      const canvas = document.createElement("canvas");
      canvas.width = videoRef.current.videoWidth;
      canvas.height = videoRef.current.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
      const photoData = canvas.toDataURL("image/png");
      setPhotos((prev) => [...prev, photoData]);
      Swal.fire({
        icon: "success",
        title: "Photo Captured",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  };

  const handleDeviceChange = (e) => {
    const deviceId = e.target.value;
    setSelectedDeviceId(deviceId);
    startCameraStream(deviceId);
  };

  useEffect(() => {
    if (showCamera && streamRef.current && videoRef.current) {
      videoRef.current.srcObject = streamRef.current;
      videoRef.current.play().catch((e) => console.error("Play error:", e));
    }
  }, [showCamera]);

  useEffect(() => {
    return () => stopCameraStream();
  }, []);

  const handleImagePicker = (event) => {
    const files = event.target.files;
    if (files) {
      const selectedPhotos = Array.from(files).map((file) =>
        URL.createObjectURL(file)
      );
      setPhotos((prev) => [...prev, ...selectedPhotos]);
    }
  };
  const [temp_vehicle, setTemp_vehicle] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);


  const handleImagesDownload = async (imageUrls = []) => {
    if (!imageUrls.length) {
      Swal.fire("Info", "No images to download.", "info");
      return;
    }

    for (let i = 0; i < imageUrls.length; i++) {
      const imageUrl = imageUrls[i].trim();
      try {
        const response = await fetch(`${globalValue}/get_image/${imageUrl}`);
        if (!response.ok) throw new Error(`Failed to fetch ${imageUrl}`);

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        const ext = imageUrl.split(".").pop() || "png";
        link.download = `${temp_vehicle}_${i + 1}.${ext}`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error(`Download failed for ${imageUrl}:`, err);
      }
    }
  };


  const [job_card_id, setJob_card_id] = useState("");

  const [img_view, setImg_view] = useState(false);
  const handleImageDelete = async (imageUrl, job_card_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This image will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          const response = await axios.post(
            `${globalValue}/delete_image`,
            {
              imageUrl,
              job_card_id,
            },
            {
              headers: {
                "x-access-token": sessionStorage.getItem("token"),
              },
            }
          );

          if (response.data === "success") {
            setImg_view(false);
            fetchDetails([]);

            Swal.fire("Deleted!", "The image has been deleted.", "success");
          }
        } catch (error) {
          console.error("Error deleting image:", error);
          Swal.fire(
            "Error!",
            "There was a problem deleting the image.",
            "error"
          );
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const [swap, setSwap] = useState(true);

  const [show1, setShow1] = useState(false);

  const [staff_coordination, setStaff_coordination] = useState([]);
  const [staffs_, setStaffs_] = useState([]);
  const fetchStaffs = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/staffs`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      console.log(response.data);

      const staffOptions = response.data
        .filter((staff) => staff[6][0] != "superadmin")
        .map((staff) => ({
          value: staff[1],
          label: staff[2],
        }));

      console.log(staffOptions);
      setStaffs_(staffOptions);
    } catch (error) {
      console.error("Error fetching staff data:", error);
    } finally {
      setLoading(false);
    }
  };
  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (show1) {
      fetchStaffs();
    }
  }, [show1]);
  const [temp_estid, setTemp_estid] = useState("");

  const cleanedImgData = Array.isArray(img_data) ? img_data : [];
  const [insurance_valid, setInsurance_valid] = useState(false);
  const [error1, setError1] = useState("");

  const checkinsuranceValidity = async (customer) => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/check_insurance`, {
        params: {
          id: customer["value"],
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      if (response.data.success === 1) {
        await setInsurance_valid(true);
      } else {
        setInsurance_valid(false);
        setError1("This customer is not able to claim insurance");
      }
    } catch (error) {
      console.error("Error fetching  data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handle_insurance_submit = async (
    surviour_name,
    mobile_no,
    email_id,
    temp_estid
  ) => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/surviour_update`, {
        params: {
          surviour_name,
          mobile_no,
          email_id,
          temp_estid,
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      if (response.data === "success") {
        Swal.fire(
          "Success!",
          "Surviour Details Updated Successfully.",
          "success"
        );
        setSurviour_model(false);
        fetchData();
        fetchDetails();
      } else {
        Swal.fire(
          "Warning!",
          "Surviour Details Not  Updated Successfully.",
          "warning"
        );
        setSurviour_model(false);
      }
    } catch (error) {
      Swal.fire(
        "Warning!",
        "Surviour Details Not  Updated Successfully.",
        "warning"
      );
      setSurviour_model(false);
    } finally {
      setLoading(false);
    }
  };

  const categoryTotal = pdf_insurance_data?.service_category?.reduce(
    (catSum, cat) =>
      catSum +
      (cat?.subcategories?.reduce(
        (sum, sub) => sum + (parseFloat(sub?.amount) || 0),
        0
      ) || 0),
    0
  );

  const sparesTotal = pdf_insurance_data?.all_spares?.reduce(
    (sum, s) => sum + (parseFloat(s?.total) || 0),
    0
  );

  const grandTotal = ((categoryTotal || 0) + (sparesTotal || 0)).toFixed(2);

  // ─── Remark: Open modal & fetch existing remark ───────────────────────────
  const handleOpenRemark = async (estimateId) => {
    setRemarkRowId(estimateId);
    setRemark("");
    setDebouncedRemark("");
    setRemarkSaved(false);
    setRemarkModalOpen(true);

    try {
      const response = await axios.get(`${globalValue}/get_remark`, {
        params: { table: "estimate_data", id: estimateId },
        headers: { "x-access-token": sessionStorage.getItem("token") },
      });
      if (response.data.success === 1) {
        setRemark(response.data.remark || "");
        setDebouncedRemark(response.data.remark || "");
      }
    } catch (error) {
      console.error("Error fetching remark:", error);
    }
  };

  // ─── Remark: Debounce logic ───────────────────────────────────────────────
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedRemark(remark);
    }, 100);
    return () => clearTimeout(handler);
  }, [remark]);

  // ─── Remark: Auto-save when debounced value changes ──────────────────────
  useEffect(() => {
    if (!remarkRowId) return;
    if (debouncedRemark === null || debouncedRemark === undefined) return;

    const saveRemarkAPI = async (value) => {
      setRemarkSaving(true);
      setRemarkSaved(false);
      try {
        await axios.post(
          `${globalValue}/save_remark`,
          { table: "estimate_data", id: remarkRowId, remark: value },
          { headers: { "x-access-token": sessionStorage.getItem("token") } }
        );
        setRemarkSaved(true);
      } catch (error) {
        console.error("Error saving remark:", error);
      } finally {
        setRemarkSaving(false);
      }
    };

    saveRemarkAPI(debouncedRemark);
  }, [debouncedRemark]);
  // ─────────────────────────────────────────────────────────────────────────

  return (
    <div>
      <div
        className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] relative  mt-16 h-[92vh] flex justify-center items-center box-border`}
      >
        <div className="absolute right-6 bottom-8 z-50">
          <button
            onClick={() => setShowCalendar(!showCalendar)}
            className="flex items-center gap-2 bg-purple-500 p-2 text-white rounded-3xl hover:bg-blue-600 transition"
          >
            <CalendarIcon size={30} />
          </button>

          {showCalendar && (
            <div className="absolute bottom-full right-0 mt-2 shadow-lg bg-white p-2 rounded-lg z-50 w-[250px] md:w-auto">
              <Calendar
                onChange={(date) => {
                  setSelectedDate(date);
                  setShowCalendar(false);
                  console.log("date" + date);
                }}
                value={selectedDate}
              />
            </div>
          )}
        </div>
        {loading && (
          <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
            <img src={engineGif} alt="Loading..." className="w-24 h-24" />
          </div>
        )}
        <div className="w-[95%] md:w-[98%] h-[95%]  bg-white px-4 py-2 rounded-xl shadow-xl overflow-auto">
          {swap ? (
            <>
              <div className="w-full flex justify-between text-gray-600 mb-6">
                <Head_data data="Estimation Details" font="" size="3xl" />
                <button
                  onClick={() => {
                    setModalOpen(true);
                    setInsurance_valid(false);
                    setDriven_km(0);
                    setError1("");
                  }}
                  className="bg-blue-500 text-white px-4 py-2 rounded"
                >
                  Add Job Card
                </button>
              </div>

              <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-4">
                <input
                  type="text"
                  placeholder="Search by Customer,Vehicle no,Brand,Model"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full md:w-1/3 px-3 py-1.5 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                />

                <div className="flex flex-wrap items-center gap-3">
                  <div className="flex flex-col gap-0.5">
                    <label className="text-xs font-medium text-gray-600">Start</label>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      className="px-2 py-1 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                    />
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <label className="text-xs font-medium text-gray-600">End</label>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      className="px-2 py-1 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200"
                    />
                  </div>
                  <button
                    onClick={() => {
                      setStartDate("");
                      setEndDate("");
                    }}
                    className="mt-4 md:mt-0 px-2 py-1 text-xs bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition"
                  >
                    Clear
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-6">
                {filtered
                  .filter((item) => {
                    if (!selectedDate) return true;
                    const itemDate = new Date(item["date"]);
                    const selectedLocalDate = new Date(selectedDate);
                    return (
                      itemDate.getFullYear() ===
                      selectedLocalDate.getFullYear() &&
                      itemDate.getMonth() === selectedLocalDate.getMonth() &&
                      itemDate.getDate() === selectedLocalDate.getDate()
                    );
                  })
                  .map((item, index) => {
                    const isOpen = openCard === index;

                    return (
                      <div
                        key={index}
                        className={`bg-white border ${item["mode"] === "main"
                          ? "border-green-400"
                          : "border-blue-400"
                          } rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden cursor-pointer`}
                        onClick={() => setOpenCard(isOpen ? null : index)}
                      >
                        <div className="p-4 flex flex-col md:flex-row md:justify-between md:items-center gap-3">
                          <div className="w-full sm:w-[400px] bg-white shadow rounded-xl p-4 text-sm text-gray-800 space-y-2">
                            {item.job_card_no && (
                              <div className="flex justify-start">
                                <span className="px-2 py-0.5 text-[10px] font-bold tracking-wider text-blue-700 bg-blue-50 border border-blue-200 rounded uppercase">
                                  Job Card: {String(item.job_card_no).padStart(4, '0')}
                                </span>
                              </div>
                            )}
                            <div className="flex justify-between items-center">
                              <div className="font-bold text-base text-gray-900">
                                {item.vehicle_no}
                              </div>
                              <div className="flex items-center gap-1 text-gray-600 text-sm">
                                {item.customer_name.length > 10
                                  ? `${item.customer_name.slice(0, 10)}...`
                                  : item.customer_name}
                                {item.insurance_status === "1" ? (
                                  <ShieldCheckIcon
                                    className="w-4 h-4 text-green-500"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSurviour_name(item.surviour_name);
                                      setMobile_no(item.mobile_no);
                                      setEmail_id(item.email_id);
                                      setSurviour_model(true);
                                      setTemp_estid(item.estimate_id);
                                    }}
                                  />
                                ) : (
                                  <ShieldExclamationIcon className="w-4 h-4 text-red-500" />
                                )}
                              </div>
                            </div>

                            <div className="flex justify-between text-gray-600">
                              <div>{item.brand}</div>
                              <div>{item.model}</div>
                              {item.driven_km > 0 ? (
                                <div className="font-semibold text-gray-800">
                                  Driven KM :{item.driven_km}km
                                </div>
                              ) : null}
                            </div>

                            <div className="text-xs text-gray-400">
                              Date:{" "}
                              {new Date(item.date).toLocaleDateString("en-GB")}
                            </div>
                          </div>

                          <div className="flex flex-wrap gap-2">
                            <button
                              className="flex items-center gap-1 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-md text-sm hover:bg-gray-200"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShow(true);
                                setEst_id(item["estimate_id"]);
                                view_details(item["estimate_id"]);
                                setBrand(item["brand"]);
                                setModel1(item["model"]);
                                setSwap(false);
                              }}
                            >
                              <FaEye className="w-4 h-4" /> Details
                            </button>

                            {sessionStorage.getItem("position") ===
                              "superadmin" && (
                                <button
                                  className="flex items-center gap-1 bg-red-100 text-red-700 px-3 py-1.5 rounded-md text-sm hover:bg-red-200"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    delete_estimate(
                                      item["estimate_id"],
                                      item["link"],
                                      "main"
                                    );
                                  }}
                                >
                                  <FaTrash className="w-4 h-4" /> Delete
                                </button>
                              )}

                            <button
                              className="flex items-center gap-1 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-md text-sm hover:bg-gray-200"
                              onClick={(e) => {
                                e.stopPropagation();
                                setTemp_brand_modal(
                                  item["brand"] + " . " + item["model"]
                                );

                                fetchData();
                                fetchData2();
                                fetchData1();
                                fetchDetails();
                                setFlag("normal");
                                setTemp_job_card_no(item.job_card_no ? String(item.job_card_no).padStart(4, '0') : "");
                                makePdf1(item);
                              }}
                            >
                              <FaPrint className="w-4 h-4" /> Print
                            </button>

                            {item["status"] === "0" && (
                              <button
                                className="flex items-center gap-1 bg-green-100 text-green-700 px-3 py-1.5 rounded-md text-sm hover:bg-green-200"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShow1(true);
                                  setStaff_coordination([]);
                                  setTemp_estid(item["estimate_id"]);
                                }}
                              >
                                <FaExchangeAlt className="w-4 h-4" /> Transfer
                              </button>
                            )}

                            <span className="text-gray-500 ml-2">
                              {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                            </span>
                          </div>
                        </div>

                        {isOpen && (
                          <div className="border-t px-4 pt-3 pb-5 bg-gray-50 transition-all duration-300">
                            <div className="flex flex-wrap gap-3">
                              <button
                                className="bg-blue-100 text-blue-700 px-4 py-2 rounded-md text-sm hover:bg-blue-200"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setAdd_show(true);
                                  add_details(item["link"]);
                                }}
                              >
                                View Estimate
                              </button>

                              <button
                                className="flex items-center gap-1 bg-gray-100 text-gray-700 px-3 py-1.5 rounded-md text-sm hover:bg-gray-200"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTemp_brand_modal(
                                    item["brand"] + " . " + item["model"]
                                  );

                                  fetchData();
                                  fetchData2();
                                  fetchData1();
                                  fetchDetails();
                                  setFlag("insurance");
                                  setTemp_job_card_no(item.job_card_no ? String(item.job_card_no).padStart(4, '0') : "");
                                  makePdf1(item);
                                }}
                              >
                                <FaPrint className="w-4 h-4" /> Print for
                                insurance
                              </button>

                              <button
                                className="flex items-center gap-1 bg-blue-50 text-blue-700 px-3 py-1.5 rounded-md text-sm hover:bg-blue-100 border border-blue-200"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setTemp_brand_modal(
                                    item["brand"] + " . " + item["model"]
                                  );

                                  fetchData();
                                  fetchData2();
                                  fetchData1();
                                  fetchDetails();
                                  setFlag("jobcard");
                                  setTemp_job_card_no(item.job_card_no ? String(item.job_card_no).padStart(4, '0') : "");
                                  makePdf1(item);
                                }}
                              >
                                <FaPrint className="w-4 h-4" /> Print Job Card
                              </button>

                              <button
                                className="bg-blue-100 text-blue-700 px-4 py-2 rounded-md text-sm hover:bg-blue-200"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setImg_view(true);
                                  setJob_card_id(item["estimate_id"]);
                                  setImg_data(item["photos"]);
                                  setSelectedImages([]);
                                  setTemp_vehicle(item["vehicle_no"] + "/" + item["customer_name"]);
                                }}
                              >
                                View Photos
                              </button>

                              {/* ─── Remark Button ──────────────────────────────── */}
                              <button
                                className="flex items-center gap-1 bg-purple-100 text-purple-700 px-4 py-2 rounded-md text-sm hover:bg-purple-200"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenRemark(item["estimate_id"]);
                                }}
                              >
                                <FaStickyNote className="w-4 h-4" /> Remark
                              </button>
                              {/* ──────────────────────────────────────────────── */}

                              <button
                                className="bg-blue-100 text-blue-700 px-4 py-2 rounded-md text-sm hover:bg-blue-200"
                                onClick={(e) => {
                                  e.stopPropagation();

                                  setJob_card_id(item["estimate_id"]);
                                  setCustomer_id(item["customer_id"]);

                                  setShowInsuranceModal(true);

                                  setCompany_name(item["company"] || "");
                                  setInsurance_branch(
                                    item["insurance_branch"] || ""
                                  );
                                  setB_mobile_no(item["b_mobile_no"] || "");
                                  setB_address_no(
                                    item["insurance_address"] || ""
                                  );
                                  setBranch_code(item["branch_code"] || "");
                                  setInsurance_no(item["insurance"] || "");
                                  setInsurance_type(
                                    item["insurance_type"] || ""
                                  );
                                  setS_date(item["s_date"] || "");
                                  setE_date(item["e_date"] || "");
                                  setRcbook(item["rcbook"] || "");
                                  setRc_start(item["rc_start"] || "");
                                  setRc_end(item["rc_end"] || "");
                                  setLicense(item["license"] || "");
                                  setLicense_start(item["license_start"] || "");
                                  setLicense_end(item["license_end"] || "");

                                  setInsurance_error("");
                                  setInsurance_type_error("");
                                  setS_date_error("");
                                  setE_date_error("");
                                  setRcbookError("");
                                  setRc_start_error("");
                                  setRc_end_error("");
                                  setLicenseError("");
                                  setLicense_start_error("");
                                  setLicense_end_error("");
                                }}
                              >
                                Add Insurance
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </>
          ) : (
            <>
              <EstimateDetailsTable
                view_data={view_data}
                view_details={view_details}
                setSwap={setSwap}
                branch={flag_branch}
                brand={brand}
                model1={model1}
              />
            </>
          )}
        </div>
      </div>

      {/* ─── Remark Modal ────────────────────────────────────────────────────── */}
      <Modal
        show={remarkModalOpen}
        size="lg"
        popup={true}
        onClose={() => {
          setRemarkModalOpen(false);
          setRemarkRowId(null);
          setRemark("");
          setDebouncedRemark("");
          setRemarkSaved(false);
        }}
      >
        <Modal.Header className="flowbite-modal-h">
          Remark
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <div className="flex flex-col gap-3">
            <textarea
              value={remark}
              onChange={(e) => {
                setRemark(e.target.value);
                setRemarkSaved(false);
              }}
              placeholder="Type your remark here... (auto-saves after 2 seconds)"
              rows={8}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 resize-none text-gray-800 text-sm transition"
            />
            <div className="flex items-center gap-2 text-sm min-h-[22px]">
              {remarkSaving && (
                <span className="text-yellow-500 flex items-center gap-1">
                  <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  Saving...
                </span>
              )}
              {!remarkSaving && remarkSaved && (
                <span className="text-green-600 flex items-center gap-1">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  Remark saved!
                </span>
              )}
              {!remarkSaving && !remarkSaved && remark !== "" && (
                <span className="text-gray-400 text-xs">Waiting to save...</span>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-h">
          <button
            onClick={() => {
              setRemarkModalOpen(false);
              setRemarkRowId(null);
              setRemark("");
              setDebouncedRemark("");
              setRemarkSaved(false);
            }}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      {/* ──────────────────────────────────────────────────────────────────────── */}

      <Modal
        show={surviour_model}
        onClose={() => setSurviour_model(false)}
        popup
      >
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
          Insurance Surviour Details
        </Modal.Header>
        <Modal.Body className="flowbite-modal-b">
          <div>
            <Label value="Surviour Name" />
            <TextInput
              type="text"
              value={surviour_name}
              onChange={(e) => setSurviour_name(e.target.value)}
              className="mt-2"
              color="white"
            />
          </div>
          <div>
            <Label value="Mobile No" />
            <TextInput
              type="text"
              value={mobile_no}
              onChange={(e) => {
                const input = e.target.value.replace(/\D/g, "");
                setMobile_no(input.slice(0, 10));
              }}
              className="mt-2"
              color="white"
              placeholder="Enter 10-digit mobile no"
            />
          </div>

          <div>
            <Label value="Email Id" />

            <TextInput
              type="email"
              value={email_id}
              onChange={(e) => {
                const input = e.target.value;

                setEmail_id(input);
              }}
              className="mt-2"
              color="white"
              placeholder="Enter valid email"
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-b">
          <button
            onClick={() => {
              handle_insurance_submit(
                surviour_name,
                mobile_no,
                email_id,
                temp_estid
              );
            }}
            className={`p-2 rounded-md shadow-xl transition-all duration-300 
                        ${!surviour_name ||
                !/^\d{10}$/.test(mobile_no) ||
                !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_id)
                ? "bg-gray-300 text-gray-500 cursor-not-allowed opacity-50"
                : "bg-blue-500 text-white hover:bg-blue-600 hover:scale-105"
              }`}
            disabled={
              !surviour_name ||
              !/^\d{10}$/.test(mobile_no) ||
              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_id)
            }
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={show1} onClose={() => setShow1(false)} popup>
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
          Choose the Staffs
        </Modal.Header>
        <Modal.Body className="flowbite-modal-b">
          <div>
            <Select
              name="staffs"
              options={staffs_}
              value={staffs_.filter((option) =>
                staff_coordination.includes(option.value)
              )}
              onChange={(selectedOptions) => {
                setStaff_coordination(
                  selectedOptions
                    ? selectedOptions.map((option) => option.value)
                    : []
                );
              }}
              isMulti
              placeholder="Select Staffs"
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              maxMenuHeight={130}
              className="mb-10"
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="flowbite-modal-b">
          <button
            onClick={() => {
              transfer_details(temp_estid, staff_coordination);
            }}
            className="bg-blue-500 p-2 rounded-md shadow-xl text-gray-100"
            disabled={!staff_coordination}
          >
            Move to Service
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showInsuranceModal}
        onClose={() => setShowInsuranceModal(false)}
        size="5xl"
        popup
      >
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
          <p className="text-lg">Insurance Details</p>
        </Modal.Header>

        <Modal.Body className="bg-white max-h-[80vh] overflow-y-auto p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <Label htmlFor="company">Insurance Company</Label>
              <select
                id="company"
                name="company"
                value={company_name}
                onChange={handleInputChange}
                className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:ring focus:ring-blue-500 ${flag_berror ? "border-red-500" : "border-gray-300"
                  }`}
                required
              >
                <option value="" disabled>
                  Company
                </option>
                {insurance.map((data, index) => (
                  <option key={index} value={data[1]}>
                    {data[2]}
                  </option>
                ))}
              </select>
              {company_error && (
                <p className="text-sm text-red-600">{company_error}</p>
              )}
            </div>

            <div className="relative">
              <Label htmlFor="insurance_branch">Insurance Branch</Label>
              <TextInput
                id="insurance_branch"
                name="insurance_branch"
                type="text"
                value={insurance_branch}
                onChange={(e) => {
                  const inputValue = e.target.value || "";
                  setInsurance_branch(inputValue);
                  setB_address_no("");
                  setB_mobile_no("");
                  setBranch_code("");
                  setValue("");
                  setFilteredOptions([
                    ...new Set(
                      branch_list
                        .map((data) => data.branch)
                        .filter(
                          (branch) =>
                            typeof branch === "string" &&
                            branch
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                        )
                    ),
                  ]);
                }}
              />
              {filteredOptions.length > 0 && (
                <ul className="absolute w-full border border-gray-300 bg-white shadow-md rounded mt-1 max-h-40 overflow-auto z-50">
                  {filteredOptions.map((option, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        const selectedBranch = branch_list.find(
                          (branch_l) => branch_l.branch === option
                        );
                        if (selectedBranch) {
                          setInsurance_branch(selectedBranch.branch || "");
                          setB_mobile_no(selectedBranch.mobile || "");
                          setB_address_no(selectedBranch.address || "");
                          setBranch_code(selectedBranch.branch_code || "");
                        }
                        setFilteredOptions([]);
                        setValue("1");
                      }}
                      className="p-2 hover:bg-blue-100 cursor-pointer"
                    >
                      {option}
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div>
              <Label>Branch Mobile No</Label>
              <TextInput
                type="number"
                value={b_mobile_no}
                onChange={(e) => setB_mobile_no(e.target.value)}
              />
            </div>
            <div>
              <Label>Branch Email</Label>
              <TextInput
                type="email"
                value={b_address_no}
                onChange={(e) => setB_address_no(e.target.value)}
              />
            </div>
            <div>
              <Label>Branch Code</Label>
              <TextInput
                type="text"
                value={branch_code}
                onChange={(e) => setBranch_code(e.target.value)}
              />
            </div>

            <div>
              <Label>Insurance Number</Label>
              <TextInput
                name="insurance"
                type="text"
                value={insurance_no}
                onChange={handleInputChange}
                required
                color={insurance_error ? "failure" : "white"}
                helperText={insurance_error}
              />
            </div>

            <div>
              <Label>Insurance Type</Label>
              <select
                name="insurance_type"
                value={insurance_type}
                onChange={handleInputChange}
                className={`block w-full px-3 py-2 border rounded-md shadow-sm focus:ring focus:ring-blue-500 ${insurance_type_error ? "border-red-500" : "border-gray-300"
                  }`}
                required
              >
                <option value="" disabled>
                  Insurance Type
                </option>
                {types.map((type, index) => (
                  <option key={index} value={type[0]}>
                    {type[0]}
                  </option>
                ))}
              </select>
              {insurance_type_error && (
                <p className="text-sm text-red-600">{insurance_type_error}</p>
              )}
            </div>

            <div>
              <Label>Insurance Start Date</Label>
              <TextInput
                name="s_date"
                type="date"
                value={s_date}
                onChange={handleInputChange}
                required
                color={s_date_error ? "failure" : "white"}
                helperText={s_date_error}
              />
            </div>
            <div>
              <Label>Insurance End Date</Label>
              <TextInput
                name="e_date"
                type="date"
                value={e_date}
                onChange={handleInputChange}
                required
                color={e_date_error ? "failure" : "white"}
                helperText={e_date_error}
              />
            </div>

            <div>
              <Label>RC Book Number</Label>
              <TextInput
                type="text"
                value={rcbook}
                onChange={handleRcbookChange}
                required
                color={rcbookError ? "failure" : "white"}
                helperText={rcbookError}
              />
            </div>
            <div>
              <Label>RC Start Date</Label>
              <TextInput
                name="rc_start"
                type="date"
                value={rc_start}
                onChange={handleInputChange}
                required
                color={rc_start_error ? "failure" : "white"}
                helperText={rc_start_error}
              />
            </div>
            <div>
              <Label>RC End Date</Label>
              <TextInput
                name="rc_end"
                type="date"
                value={rc_end}
                onChange={handleInputChange}
                required
                color={rc_end_error ? "failure" : "white"}
                helperText={rc_end_error}
              />
            </div>

            <div>
              <Label>Driver License Number</Label>
              <TextInput
                type="text"
                value={license}
                onChange={handleLicenseChange}
                required
                color={licenseError ? "failure" : "white"}
                helperText={licenseError}
              />
            </div>
            <div>
              <Label>License Start Date</Label>
              <TextInput
                name="license_start"
                type="date"
                value={license_start}
                onChange={handleInputChange}
                required
                color={license_start_error ? "failure" : "white"}
                helperText={license_start_error}
              />
            </div>
            <div>
              <Label>License End Date</Label>
              <TextInput
                name="license_end"
                type="date"
                value={license_end}
                onChange={handleInputChange}
                required
                color={license_end_error ? "failure" : "white"}
                helperText={license_end_error}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="flex justify-end p-4">
          <button
            onClick={handleSubmitInsurance}
            className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
          >
            Submit Insurance
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={img_view} onClose={() => setImg_view(false)}>
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
          Image Preview
        </Modal.Header>
        <Modal.Body className="flowbite-modal-b">
          {cleanedImgData.length > 0 ? (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {cleanedImgData.map((imageUrl, index) => {
                  const trimmedUrl = imageUrl.trim();
                  const isChecked = selectedImages.includes(trimmedUrl);

                  return (
                    <div key={index} className="relative w-full border p-1 rounded-lg">
                      <input
                        type="checkbox"
                        className="absolute top-2 left-2 z-10 w-4 h-4 cursor-pointer"
                        checked={isChecked}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedImages((prev) => [...prev, trimmedUrl]);
                          } else {
                            setSelectedImages((prev) =>
                              prev.filter((url) => url !== trimmedUrl)
                            );
                          }
                        }}
                      />

                      <img
                        src={`${globalValue}/get_image/${trimmedUrl}`}
                        alt={`Preview ${index + 1}`}
                        className="w-full max-h-[300px] object-contain rounded-lg cursor-pointer"
                        onClick={() => {
                          if (isChecked) {
                            setSelectedImages((prev) =>
                              prev.filter((url) => url !== trimmedUrl)
                            );
                          } else {
                            setSelectedImages((prev) => [...prev, trimmedUrl]);
                          }
                        }}
                      />

                      <div className="absolute top-2 right-2 flex space-x-2">
                        <FaDownload
                          className="text-white bg-blue-600 p-1 rounded-full cursor-pointer"
                          title="Download"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleImagesDownload([trimmedUrl]);
                          }}
                        />

                        {sessionStorage.getItem("position") === "superadmin" && (
                          <FaTrash
                            className="text-white bg-red-600 p-1 rounded-full cursor-pointer"
                            title="Delete"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleImageDelete(trimmedUrl, job_card_id);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>

              {selectedImages.length > 0 && (
                <div className="mt-4 text-center">
                  <button
                    className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
                    onClick={() => handleImagesDownload(selectedImages)}
                  >
                    Download Selected ({selectedImages.length})
                  </button>
                </div>
              )}
            </>
          ) : (
            <p className="text-center text-gray-500">No images available</p>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={pdfpopup}
        size="6xl"
        popup={true}
        onClose={() => setPdfpopup(false)}
      >
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200"></Modal.Header>
        <Modal.Body className="flowbite-modal-b">
          <div
            id="pdf-content"
            className="border border-gray-500 mx-2 bg-white p-6 text-gray-800"
          >
            <div className="flex items-center mb-2">
              <div className="">
                <img
                  src={Logo}
                  alt="JALS Automobiles Logo"
                  className="h-16 w-auto"
                />
              </div>

              <div className="flex-1 text-center">
                <h2 className="text-2xl font-bold uppercase">
                  JALS AUTOMOBILES
                </h2>

                {sessionStorage.getItem("branch") === "JBRANCH2025030" ? (
                  <>
                    <p>
                      Door No : 6/63, Jals Road, Kuppottu Vilai,
                      <br />
                      Kadamacode, Melpuram, Pacode Post - 629168
                    </p>
                    <p>Ph : 04651-264007 | Mob : 8300451644</p>
                    <p>GSTIN : 33AMEPL9265E1Z1</p>
                  </>
                ) : (
                  <>
                    <p>
                      6/31 F, Karavilagam Road, Chennithottam Junction, Vettuvanni,
                      <br />
                      Marthandam - 629162
                    </p>
                    <p>Ph: 04651-271220 | Mob: 9488495820</p>
                    <p>GSTIN: 33AMEPL9265E1Z1</p>
                  </>
                )}
              </div>

            </div>

            <div className="flex justify-between items-center">
              <h3 className="text-lg font-bold">ESTIMATE</h3>
              <div className="flex flex-col items-end">
                {temp_job_card_no && (
                  <p>
                    Job Card No: <span className="font-semibold">{temp_job_card_no}</span>
                  </p>
                )}
                <p>
                  Date:{" "}
                  <span className="font-semibold">
                    {new Date(pdf_data?.estimate_date).toLocaleDateString(
                      "en-GB"
                    )}
                  </span>
                </p>
              </div>
            </div>

            <div className="border border-gray-400 p-4 mt-2 mb-2">
              <p>
                <strong>To:</strong> {pdf_data?.customer_name}
              </p>
              <p>Address: {pdf_data?.address}</p>
              <p>
                Vehicle No: {pdf_data?.vehicle_no} {temp_brand_modal}
              </p>
              <p>Phone: {pdf_data?.mobile_no}</p>
              {pdf_data?.driven_km > 0 ? (
                <p>KM Driven: {pdf_data?.driven_km} KM</p>
              ) : null}
            </div>

            {pdf_data["services"]?.map((service, serviceIndex) => {
              const matchingCategories = pdf_data?.service_category?.filter(
                (cat) =>
                  String(cat?.service_name)
                    ?.trim()
                    .toLowerCase() ===
                  String(service?.service_name)
                    ?.trim()
                    .toLowerCase()
              );

              return (
                <div key={serviceIndex} className="mb-8">
                  {service?.spares?.length > 0 ||
                    (matchingCategories[0]?.service_name ===
                      service?.service_name &&
                      matchingCategories[0]?.subcategories?.length > 0) ? (
                    <div className="flex w-full h-10 justify-between px-4 items-center bg-gray-300 border-b border-gray-500">
                      <p>Service: {service.service_name}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  {service?.spares?.length > 0 ? (
                    <table className="w-full border border-gray-300 mt-1">
                      <thead>
                        <tr className="bg-gray-200">
                          <th className="border p-3 w-[10%] text-left">Sno</th>
                          <th className="border p-3 w-[50%] text-left">Item</th>
                          <th className="border p-3 w-[10%] text-left">
                            Quantity
                          </th>
                          <th className="border p-3 w-[20%] text-right">
                            Price/Unit
                          </th>
                          <th className="border p-3 w-[20%] text-right">
                            Total
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {service.spares?.map((item, index) => (
                          <tr key={index}>
                            <td className="border p-3 text-center">
                              {index + 1}
                            </td>
                            <td className="border p-3">{item.spare_name}</td>
                            <td className="border p-3 text-center">
                              {item.quantity}
                            </td>
                            <td className="border p-3 text-right">
                              {Number(item.price).toFixed(2)}
                            </td>
                            <td className="border p-3 text-right">
                              {Number(item.total).toFixed(2)}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="3" className="border p-3 text-start">
                            Service Total (Excl. Labour)
                          </td>
                          <td className="border p-3 text-center">Total</td>
                          <td className="border p-3 text-right">
                            Rs.
                            {(
                              Number(service.service_grand_total) -
                              Number(service.labour_charge || 0)
                            ).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ) : (
                    ""
                  )}

                  {matchingCategories.length > 0 &&
                    matchingCategories.map((cat, idx) => {
                      const catTotal =
                        cat.subcategories?.reduce(
                          (sum, sub) => sum + (parseFloat(sub.amount) || 0),
                          0
                        ) || 0;

                      return (
                        <div key={idx} className="mt-4">
                          <h3 className="font-semibold">Service Charges</h3>
                          <table className="w-full border border-gray-300 text-sm mt-1">
                            <thead>
                              <tr className="bg-gray-100">
                                <th className="border px-2 pb-2">
                                  Subcategory
                                </th>
                                <th className="border px-2 pb-2">Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {cat.subcategories?.map((sub, sidx) => (
                                <tr key={sidx}>
                                  <td className="border px-2 py-1">
                                    {sub.name || ""}
                                  </td>
                                  <td className="border px-2 py-1 text-right">
                                    {Number(sub.amount || 0).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td className="font-bold text-right border px-2 py-1">
                                  Total
                                </td>
                                <td className="font-bold border px-2 py-1 text-right">
                                  {Number(catTotal).toFixed(2)}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                </div>
              );
            })}

            <div className="mt-8">
              <h3 className="text-lg font-bold mb-2">Labour Charges Summary</h3>
              <table className="w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 p-3 text-left">
                      Service Name
                    </th>
                    <th className="border border-gray-300 p-3 text-right">
                      Labour Charge
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {pdf_data["services"]?.map((service, index) => {
                    if (Number(service["labour_charge"]) > 0) {
                      return (
                        <tr key={index}>
                          <td className="border border-gray-300 p-3">
                            {service["service_name"]}
                          </td>
                          <td className="border border-gray-300 p-3 text-right">
                            Rs.{Number(service["labour_charge"]).toFixed(2)}
                          </td>
                        </tr>
                      );
                    } else return null;
                  })}
                  <tr>
                    <td className="border border-gray-300 p-3 font-semibold text-start">
                      Total Labour Charges
                    </td>
                    <td className="border border-gray-300 p-3 text-right font-semibold">
                      Rs.
                      {pdf_data["services"]
                        ?.reduce(
                          (sum, s) => sum + Number(s["labour_charge"] || 0),
                          0
                        )
                        .toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="flex justify-between px-4 mt-2 mb-6">
              <div className="text-md font-semibold">
                {pdf_data["overall_grand_total_in_words"]}
              </div>
              <div className="text-md font-semibold">
                Grand Total: Rs.
                {Number(pdf_data["overall_grand_total"]).toFixed(2)}
              </div>
            </div>

            <div className="mt-6 flex justify-between">
              <div>
                <p className="font-bold">For JALS AUTOMOBILES</p>
              </div>
              <div className="text-right">
                <p className="font-bold">Authorized Signatory</p>
              </div>
            </div>
          </div>
          <style>
            {`
                    @media print {
                    body * {
                      visibility: hidden;
                    }
                    #pdf-content, #pdf-content * {
                      visibility: visible;
                    }
                    #pdf-content {
                      margin: 0 auto;
                      box-shadow: none;
                      border: none;
                      width: 100%;
                    }
                    #pdf-content .flex {
                      display: block !important;
                      page-break-inside: avoid;
                    }
                    .mb-2, .mt-2, .mt-4, .mt-6, .mt-8, .mb-6, .mb-8 {
                      margin: 4px 0 !important;
                    }
                    .page-break {
                      page-break-before: auto !important;
                      margin-top: 0 !important;
                      padding-top: 0 !important;
                    }
                    table, tr, td, th {
                      page-break-inside: avoid !important;
                    }
                  }
    `}
          </style>
        </Modal.Body>

        <Modal.Footer className="flowbite-modal-b">
          <button
            onClick={() => handlePrint()}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            Print
          </button>
        </Modal.Footer>
      </Modal>

      {/* ─── pdfpopup1: Quotation / Job Card / Insurance PDF Modal ─────────── */}
      <Modal
        show={pdfpopup1}
        size="6xl"
        popup={true}
        onClose={() => setPdfpopup1(false)}
      >
        <Modal.Header className="bg-white text-gray-900 border-b border-gray-200"></Modal.Header>
        <Modal.Body className="flowbite-modal-b">
          <div
            id="pdf-content"
            className="mx-auto bg-white p-8 text-gray-800 border border-gray-400 shadow-md max-w-3xl print:p-4 print:shadow-none"
          >
            <div className="flex items-center border-b pb-4">
              <div>
                <img
                  src={Logo}
                  alt="JALS Automobiles Logo"
                  className="h-16 w-auto"
                />
              </div>
              <div className="flex-1 text-center">
                <h2 className="text-2xl font-bold uppercase">
                  JALS AUTOMOBILES
                </h2>

                {sessionStorage.getItem("branch") === "JBRANCH2025030" ? (
                  <>
                    <p>
                      Door No : 6/63, Jals Road, Kuppottu Vilai,
                      <br />
                      Kadamacode, Melpuram, Pacode Post - 629168
                    </p>
                    <p>Ph : 04651-264007 | Mob : 8300451644</p>
                    <p>GSTIN : 33AMEPL9265E1Z1</p>
                  </>
                ) : (
                  <>
                    <p>
                      6/31 F, Karavilagam Road, Chennithottam Junction, Vettuvanni,
                      <br />
                      Marthandam - 629162
                    </p>
                    <p>Ph: 04651-271220 | Mob: 9488495820</p>
                    <p>GSTIN: 33AMEPL9265E1Z1</p>
                  </>
                )}
              </div>

            </div>

            <div className="text-center mt-2">
              <p className="font-semibold underline text-lg">
                {flag === "jobcard" ? "JOB CARD" : "QUOTATION"}
              </p>
            </div>
            <div className="flex justify-between items-center mt-1 mb-2 text-sm">
              <div>
                {temp_job_card_no && (
                  <p>
                    Job Card No: <span className="font-semibold">{temp_job_card_no}</span>
                  </p>
                )}
              </div>
              <p>
                Date:{" "}
                <span className="font-semibold">
                  {new Date(
                    pdf_insurance_data?.estimate_date
                  ).toLocaleDateString("en-GB")}
                </span>
              </p>
            </div>
            {flag === "insurance" && <>
              <h2 className="text-lg font-bold pb-1">Insurance Details</h2>
              <table className="w-full mb-2 border border-gray-400 text-sm border-collapse">
                <tbody>
                  <tr>
                    <td className="font-semibold border px-3 pb-2 w-1/3">
                      Insurance Company
                    </td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_company || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">Branch</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_branch || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">
                      Branch Code
                    </td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.branch_code || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">
                      Branch Mobile
                    </td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_branch_mobile ||
                        "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">
                      Insurance No
                    </td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.insurance_no || "-"}
                    </td>
                  </tr>
                  <tr>
                    <td className="font-semibold border px-3 pb-2">GST No</td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.insurance?.gst_no || "-"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </>}
            <h2 className="text-lg font-bold pb-2 mt-2">Customer Details</h2>
            <table className="w-full mb-3 border border-gray-400 text-sm border-collapse">
              <tbody>
                <tr>
                  <td className="font-semibold border px-3 pb-2 w-1/3">
                    Customer Name
                  </td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.customer_name || ""}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Vehicle No</td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.vehicle_no || ""}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Mobile No</td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.mobile_no || ""}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Brand</td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.brand || ""}
                  </td>
                </tr>
                <tr>
                  <td className="font-semibold border px-3 pb-2">Model</td>
                  <td className="border px-3 pb-2">
                    {pdf_insurance_data?.model || ""}
                  </td>
                </tr>
                {pdf_insurance_data?.driven_km > 0 ? (
                  <tr>
                    <td className="font-semibold border px-3 pb-2">
                      Driven KM
                    </td>
                    <td className="border px-3 pb-2">
                      {pdf_insurance_data?.driven_km || ""}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>

            {flag !== "jobcard" && (pdf_insurance_data?.all_spares || []).length > 0 && (
              <>
                <h2 className="text-lg font-bold pb-2 mt-2">All Spares</h2>
                <table className="w-full mb-3 border border-gray-400 text-sm border-collapse">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="border px-3 pb-2 text-left">Spare Name</th>
                      <th className="border px-3 pb-2 text-center">Quantity</th>
                      <th className="border px-3 pb-2 text-right">Price</th>
                      <th className="border px-3 pb-2 text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pdf_insurance_data?.all_spares?.map((spare, i) => (
                      <tr key={i}>
                        <td className="border px-3 pb-2">
                          {spare?.spare_name || ""}
                        </td>
                        <td className="border px-3 pb-2 text-center">
                          {spare?.quantity || ""}
                        </td>
                        <td className="border px-3 pb-2 text-right">
                          {Number(spare?.price || 0).toFixed(2)}
                        </td>
                        <td className="border px-3 pb-2 text-right">
                          {Number(spare?.total || 0).toFixed(2)}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td
                        colSpan={3}
                        className="font-bold text-right border px-3 pb-2"
                      >
                        Total
                      </td>
                      <td className="font-bold border px-3 pb-2 text-right">
                        {Number(
                          pdf_insurance_data?.all_spares?.reduce(
                            (sum, s) => sum + (parseFloat(s?.total) || 0),
                            0
                          )
                        ).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </>
            )}

            {flag !== "jobcard" && (pdf_insurance_data?.service_category || []).filter((cat) => (cat?.subcategories || []).length > 0).length > 0 && (
              <>
                <h2 className="text-lg font-bold mb-2 border-b pb-1">
                  Service Categories
                </h2>
                {(pdf_insurance_data?.service_category || [])
                  .filter((cat) => (cat?.subcategories || []).length > 0)
                  .map((cat, idx) => {
                    const catTotal = (cat?.subcategories || []).reduce(
                      (sum, sub) => sum + (parseFloat(sub?.amount) || 0),
                      0
                    );
                    return (
                      <div key={idx} className="mb-2">
                        <h3 className="font-semibold mb-1">
                          {cat?.service_name || "Unnamed Service"}
                        </h3>
                        <table className="w-full border border-gray-400 text-sm border-collapse">
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border px-3 pb-2 text-left">
                                Subcategory
                              </th>
                              <th className="border px-3 pb-2 text-right">
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {(cat?.subcategories || []).map((sub, sidx) => (
                              <tr key={sidx}>
                                <td className="border px-3 pb-2">
                                  {sub?.name || "Unnamed Sub"}
                                </td>
                                <td className="border px-3 pb-2 text-right">
                                  {Number(sub?.amount || 0).toFixed(2)}
                                </td>
                              </tr>
                            ))}
                            <tr>
                              <td className="font-bold text-right border px-3 pb-2">
                                Total
                              </td>
                              <td className="font-bold border px-3 pb-2 text-right">
                                {Number(catTotal || 0).toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    );
                  })}
              </>
            )}

            {(() => {
              const categories = pdf_insurance_data?.service_category || [];
              const services = pdf_insurance_data?.services || [];

              const categoryBasedLabourServices = categories
                .filter((cat) => (cat?.subcategories || []).length === 0)
                .map((cat) =>
                  services.find((s) => s.service_name === cat.service_name)
                )
                .filter(Boolean);

              const uncategorizedLabourServices = services.filter(
                (s) =>
                  !categories.some((cat) => cat.service_name === s.service_name)
              );

              const labourOnlyServices = [
                ...categoryBasedLabourServices,
                ...uncategorizedLabourServices,
              ].filter((s) => (s?.labour_charge || 0) > 0);

              return flag !== "jobcard" && labourOnlyServices.length > 0 ? (
                <>
                  <h2 className="text-lg font-bold mb-2 border-b pb-2">
                    Labour Charges
                  </h2>
                  {labourOnlyServices.map((service, idx) => (
                    <div key={idx} className="mb-2">
                      <table className="w-full border border-gray-400 text-sm border-collapse">
                        <tbody>
                          <tr>
                            <td className="font-bold text-left border px-3 pb-2">
                              {service?.service_name || "Unnamed Service"}
                            </td>
                            <td className="font-bold border px-3 pb-2 text-right">
                              {Number(service?.labour_charge || 0).toFixed(2)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ))}
                </>
              ) : null;
            })()}

            {(() => {
              const categories = pdf_insurance_data?.service_category || [];
              const services = pdf_insurance_data?.services || [];
              const allSpares = pdf_insurance_data?.all_spares || [];

              const sparesTotal = allSpares.reduce(
                (sum, s) => sum + (parseFloat(s?.total) || 0),
                0
              );

              const servicesTotal = categories.reduce(
                (catSum, cat) =>
                  catSum +
                  (cat?.subcategories || []).reduce(
                    (subSum, sub) => subSum + (parseFloat(sub?.amount) || 0),
                    0
                  ),
                0
              );

              const categoryBasedLabourServices = categories
                .filter((cat) => (cat?.subcategories || []).length === 0)
                .map((cat) =>
                  services.find((s) => s.service_name === cat.service_name)
                )
                .filter(Boolean);

              const uncategorizedLabourServices = services.filter(
                (s) =>
                  !categories.some((cat) => cat.service_name === s.service_name)
              );

              const labourTotal = [
                ...categoryBasedLabourServices,
                ...uncategorizedLabourServices,
              ].reduce(
                (sum, service) =>
                  sum + (parseFloat(service?.labour_charge) || 0),
                0
              );

              const grandTotal = (
                sparesTotal +
                servicesTotal +
                labourTotal
              ).toFixed(2);

              return flag !== "jobcard" ? (
                <>
                  <div className="page-break"></div>
                  <p className="font-bold text-right text-lg">
                    Grand Total : {grandTotal}
                  </p>
                  <p className="pt-2 font-semibold text-sm">
                    Remark : Taxes extra. Conditions applied.
                  </p>
                  {/* ─── Print the fetched remark below the standard remark line ─── */}
                  {pdfRemark && pdfRemark.trim() !== "" && (
                    <div
                      className="mt-2 p-3 border border-gray-300 rounded text-sm text-gray-700"
                      style={{ wordBreak: "break-word", whiteSpace: "pre-wrap", width: "100%" }}
                    >
                      <span className="font-semibold">Note : </span>
                      {pdfRemark}
                    </div>
                  )}
                  {/* ────────────────────────────────────────────────────────────── */}
                </>
              ) : null;
            })()}
          </div>
          <style>
            {`
                .page-break-inside-avoid {
                  page-break-inside: avoid;
                }
                table {
                  page-break-inside: auto;
                }
                tr {
                  page-break-inside: avoid;
                  page-break-after: auto;
                }  
            `}
          </style>
        </Modal.Body>

        <Modal.Footer className="flowbite-modal-b">
          <button
            onClick={() => handlePrint()}
            className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
          >
            Print
          </button>
        </Modal.Footer>
      </Modal>
      {/* ──────────────────────────────────────────────────────────────────────── */}

      {add_show && (
        <Modal
          show={add_show}
          size={add_data.length === 1 ? "lg" : "4xl"}
          popup={true}
          onClose={() => setAdd_show(false)}
        >
          <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
            Estimates
          </Modal.Header>
          <Modal.Body className="flowbite-modal-b">
            <div
              id="pdf-content"
              className={`grid ${add_data.length === 1
                ? "grid-cols-1"
                : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-2"
                } gap-6`}
            >
              {add_data.map((item, index) => (
                <div
                  key={index}
                  className={`bg-white border-2 ${item["mode"] === "main"
                    ? "border-green-500"
                    : "border-blue-500"
                    } p-8 rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300 ease-in-out relative`}
                >
                  <div className="text-xl font-semibold text-gray-800">
                    <span className="text-gray-500">
                      {item["vehicle_no"]} ({item["customer_name"]})
                    </span>
                  </div>

                  <div className="mt-3 text-md text-gray-600">
                    {item["brand"]}-{item["model"]}
                  </div>

                  <div className="mt-2 text-sm text-gray-500">
                    <span className="font-medium text-gray-700 hidden md:inline-block">
                      Date:
                    </span>{" "}
                    {item["date"]}
                  </div>

                  <div className="absolute top-1 right-2 flex flex-col gap-1">
                    <button
                      data-tooltip-id="tooltip_eye"
                      className="bg-blue-500 text-white p-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none"
                      onClick={() => {
                        setShow(true);
                        setEst_id(item["estimate_id"]);
                        view_details(item["estimate_id"]);
                        setSwap(false);
                        setAdd_show(false);
                        setBrand(item["brand"]);
                        setModel1(item["model"]);
                      }}
                    >
                      <FaEye />
                    </button>

                    {sessionStorage.getItem("position") === "superadmin" ? (
                      <button
                        data-tooltip-id="tooltip_delete_add"
                        className="bg-red-500 text-white p-2 rounded-md shadow-md hover:bg-red-600 focus:outline-none"
                        onClick={() =>
                          delete_estimate(
                            item["estimate_id"],
                            item["link"],
                            "sub"
                          )
                        }
                      >
                        <FaTrash />
                      </button>
                    ) : null}

                    <button
                      className="bg-blue-500 text-white p-2 rounded-md shadow-md hover:bg-blue-600 focus:outline-none"
                      data-tooltip-id="tooltip_print_add"
                      onClick={() => {
                        fetchData();
                        fetchData2();
                        fetchData1();
                        fetchDetails();
                        setTemp_job_card_no(item.job_card_no ? String(item.job_card_no).padStart(4, '0') : "");
                        makePdf(item);
                      }}
                    >
                      <FaPrint />
                    </button>

                    {item["status"] === "0" && (
                      <button
                        data-tooltip-id="tooltip_transfer"
                        className="bg-green-500 text-white p-2 rounded-md shadow-md hover:bg-green-600 focus:outline-none"
                        onClick={() => {
                          setShow1(true);
                          setStaff_coordination([]);
                          setTemp_estid(item["estimate_id"]);
                        }}
                      >
                        <FaExchangeAlt />
                      </button>
                    )}
                    <Tooltip
                      id="tooltip_print_add"
                      place="top"
                      content="print the estimate details"
                    />
                    <Tooltip
                      id="tooltip_delete_add"
                      place="top"
                      content="delete this estimate"
                    />
                    <Tooltip
                      id="tooltip_eye"
                      place="top"
                      content="View the details of estimate"
                    />
                    <Tooltip
                      id="tooltip_transfer"
                      place="top"
                      content="move this estimate to service "
                    />
                  </div>
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      )}

      <Tooltip
        id="tooltip_eye"
        place="top"
        content="View the details of estimate"
      />
      <Tooltip
        id="tooltip_delete"
        place="top"
        content="Delete the this estimate as well as additional estimate"
      />

      <Tooltip
        id="tooltip_print"
        place="top"
        content=" print the whole related estimate"
      />

      <Tooltip
        id="tooltip_transfer"
        place="top"
        content="move this estimate to service "
      />
      <Tooltip
        id="tooltip_view"
        place="top"
        content="view additional estimates"
      />
      <Tooltip
        id="tooltip_add"
        place="top"
        content="Add corresponding additional estimate"
      />
      <Tooltip
        id="tooltip_photo"
        place="top"
        content="view photos of this estimate"
      />

      {modalOpen && (
        <Modal
          show={modalOpen}
          size="md"
          popup={true}
          onClose={() => setModalOpen(false)}
        >
          <Modal.Header className="bg-white text-gray-900 border-b border-gray-200">
            Customer
          </Modal.Header>
          <Modal.Body className="flowbite-modal-b">
            <div className="space-y-6">
              <div>
                <Label value="Select Customer" />
                <Select
                  options={customers}
                  onChange={async (selected) => {
                    await checkinsuranceValidity(selected);
                    setSelectedCustomer(selected);
                  }}
                  isSearchable
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  maxMenuHeight={130}
                  placeholder="Search for a customer..."
                  className="mt-2"
                  getOptionLabel={(option) =>
                    `${option.label} (${option.v_no})`
                  }
                  getOptionValue={(option) => option.value}
                  filterOption={(candidate, input) => {
                    const lowerCaseInput = input.toLowerCase();
                    const lowerCaseLabel = (
                      candidate.label || ""
                    ).toLowerCase();
                    const lowerCaseVNo = (candidate.v_no || "").toLowerCase();

                    return (
                      lowerCaseLabel.includes(lowerCaseInput) ||
                      lowerCaseVNo.includes(lowerCaseInput)
                    );
                  }}
                />
              </div>
              <div>
                <Label value="Select Date" />
                <TextInput
                  type="date"
                  value={date}
                  disabled={sessionStorage.getItem("position") !== "superadmin"}
                  onChange={(e) => setDate(e.target.value)}
                  className="mt-2"
                  color="white"
                />
              </div>
              <div>
                <Label value="Driven KM" />
                <TextInput
                  type="number"
                  value={driven_km}
                  onChange={(e) => setDriven_km(e.target.value)}
                  className="mt-2"
                  color="white"
                />
              </div>
              {insurance_valid ? (
                <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={insurance_valid}
                    onChange={(e) => setInsurance_valid(!insurance_valid)}
                    className="w-5 h-5"
                  />
                  {insurance_valid && (
                    <span className="text-sm text-gray-700">
                      Check whether the vehicle is driven by the owner; if not,
                      uncheck!
                    </span>
                  )}
                </div>
              ) : (
                <p className="text-red-500">{error1}</p>
              )}

              <div>
                <Label value="Add Photos" />
                <div className="flex space-x-2">
                  <button
                    onClick={handleOpenCamera}
                    className="bg-green-500 text-white px-4 py-2 rounded"
                  >
                    Open Camera
                  </button>
                  <input
                    id="mobile-camera-input"
                    type="file"
                    accept="image/*"
                    capture="environment"
                    className="hidden"
                    onChange={(e) => {
                      const file = e.target.files[0];
                      if (file) {
                        const reader = new FileReader();
                        reader.onload = (event) => {
                          setPhotos((prev) => [...prev, event.target.result]);
                          Swal.fire({
                            icon: "success",
                            title: "Photo Captured",
                            toast: true,
                            position: "top-end",
                            showConfirmButton: false,
                            timer: 1500,
                          });
                        };
                        reader.readAsDataURL(file);
                      }
                    }}
                  />
                  <label
                    htmlFor="imagePicker"
                    className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer"
                  >
                    Select Images
                  </label>
                  <input
                    id="imagePicker"
                    type="file"
                    accept="image/*"
                    multiple
                    className="hidden"
                    onChange={(e) => handleImagePicker(e)}
                  />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
                  {photos.map((photo, index) => (
                    <div key={index} className="relative">
                      <img
                        src={photo}
                        alt={`Captured ${index + 1}`}
                        className="w-full h-32 object-cover rounded shadow"
                      />
                      <button
                        onClick={() =>
                          setPhotos((prev) =>
                            prev.filter((_, i) => i !== index)
                          )
                        }
                        className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
                      >
                        &times;
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="flowbite-modal-b">
            <button
              onClick={() => handleSave()}
              className="bg-green-500 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
            <button
              onClick={() => setModalOpen(false)}
              className="bg-gray-300 text-gray-700 px-4 py-2 rounded ml-2"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>
      )}

      {/* Camera Modal */}
      <Modal show={showCamera} onClose={handleCloseCamera} size="xl">
        <Modal.Header>Take Photo</Modal.Header>
        <Modal.Body>
          <div className="flex flex-col items-center space-y-4">
            {videoDevices.length > 1 && (
              <select
                className="mb-2 p-2 border rounded"
                value={selectedDeviceId}
                onChange={handleDeviceChange}
              >
                {videoDevices.map(device => (
                  <option key={device.deviceId} value={device.deviceId}>
                    {device.label || `Camera ${device.deviceId.slice(0, 5)}...`}
                  </option>
                ))}
              </select>
            )}
            <div className="w-full bg-black rounded overflow-hidden relative" style={{ minHeight: '300px', display: 'flex', justifyContent: 'center' }}>
              <video
                ref={videoRef}
                autoPlay
                playsInline
                muted
                className="max-h-[60vh] object-contain"
              />
            </div>
            <div className="flex space-x-4">
              <button
                onClick={handleCapturePhoto}
                className="bg-blue-600 text-white px-6 py-2 rounded-full font-bold shadow hover:bg-blue-700 transition"
              >
                Capture
              </button>
              <button
                onClick={handleCloseCamera}
                className="bg-gray-500 text-white px-6 py-2 rounded-full font-bold shadow hover:bg-gray-600 transition"
              >
                Done
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Estimate_data;